import { render, staticRenderFns } from "./Sekou.vue?vue&type=template&id=0a225d30&scoped=true&"
import script from "./Sekou.vue?vue&type=script&lang=js&"
export * from "./Sekou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a225d30",
  null
  
)

export default component.exports